export async function importModule() {
    return await import(/* webpackChunkName: "jspdf" */ 'jspdf');
}